<style src="./spot-monitor.scss" lang="scss"></style>
<template>
  <section class="spot-monitor">
    <div class="photos">
      <div class="miniature">
        <img
          class="img"
          v-for="(spot, spotIdx) in spots"
          :key="spotIdx"
          :src="`${orianaPath}${spot.fileName}.jpg?t=${uniqueId}`"
          :alt="spot.name"
          @click="selectSpot(spot)"
        />
      </div>

      <div class="photo">
        <img class="img" :src="selectedPhotoFileName" alt="main photo" />
      </div>
    </div>

    <form class="commands" @submit.prevent="registerLicencePlate">
      <input class="licenceplate" type="text" v-model="form.licencePlate" />

      <button
        type="submit"
        class="button button__register"
        v-if="hasLicencePlate"
        :disabled="form.submitDisabled"
      >
        Registrar
      </button>
      <button
        type="submit"
        class="button button__empty"
        v-if="!hasLicencePlate"
        :disabled="form.submitDisabled"
      >
        Vaga Vazia
      </button>
    </form>
  </section>
</template>

<script>
import { URI_ORIANA, URI_TARIFF_PLAN } from '@/config/config';
import { toast } from '@/plugins/toast';

export default {
  props: {
    spots: [],
  },
  data: () => ({
    lastRegisters: [],
    orianaPath: `${URI_ORIANA}ocr/`,
    selectedSpot: null,
    form: {
      licencePlate: '',
      submitDisabled: false,
    },
    uniqueId: '000',
  }),
  computed: {
    selectedPhotoFileName() {
      if (this.selectedSpot) {
        return `${this.orianaPath}${this.selectedSpot.fileName}.jpg?t=${this.uniqueId}`;
      }

      return '';
    },
    hasLicencePlate() {
      return this.form.licencePlate.trim().toLowerCase();
    },
  },
  watch: {
    spots(v) {
      if (v.length) this.selectedSpot = v[0];
    },
  },
  mounted() {
    setInterval(() => {
      this.uniqueId = Math.floor(1000 + Math.random() * 9000);
    }, 10000);
  },
  methods: {
    selectSpot(spot) {
      this.selectedSpot = spot;
    },
    async registerLicencePlate() {
      const licencePlate = this.hasLicencePlate;
      this.form.submitDisabled = true;
      const spotUsageVehicle = await this.checkSpotUsage();
      const vehicleInSpot = spotUsageVehicle && spotUsageVehicle.licencePlate;

      // Do nothing if the vehicle parked is the same as the try
      if (vehicleInSpot && vehicleInSpot === licencePlate) {
        this.form.submitDisabled = false;
        toast.success(
          `Registrado ${licencePlate}`,
          `Veículo já estacionado`,
        );
        return;
      }

      // Do nothing if the vehicle parked is the same as the try
      if (!vehicleInSpot && !licencePlate) {
        this.form.submitDisabled = false;
        toast.success(
          `Registrado ${licencePlate}`,
          `Sem veículo na vaga`,
        );
        return;
      }

      // Just park vehicle in spot
      if (!spotUsageVehicle && licencePlate) {
        await this.parkVehicleInSpot();
        toast.success(`Estacionado ${licencePlate}\n`);
      }

      // Just remove Parked Vehicle
      if (spotUsageVehicle && !licencePlate) {
        await this.removeParkedVehicle();
        toast.success(`Retirado da vaga ${vehicleInSpot}`);
      }

      // Remove parked vehicle and Park the new one
      if (spotUsageVehicle && licencePlate) {
        await this.removeParkedVehicle();
        await this.parkVehicleInSpot();
        toast.success(
          `Retirado ${vehicleInSpot}<br />Inserido ${licencePlate}`,
        );
      }
      this.form.submitDisabled = false;
      this.form.licencePlate = '';
    },
    async removeParkedVehicle() {
      const token = this.$store.getters['DATA-ACCESS/tokenAuth'];
      const payload = {
        spotId: this.spots[0].spotId,
      };
      const opts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      };
      try {
        const data = await fetch(`${URI_TARIFF_PLAN}takeout-spot`, opts);
        const { vehicle } = await data.json();
        return vehicle;
      } catch (error) {
        console.error(error);
      }
    },
    async checkSpotUsage() {
      const token = this.$store.getters['DATA-ACCESS/tokenAuth'];
      const spotId = this.spots[0].spotId;
      const opts = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      };
      try {
        const data = await fetch(
          `${URI_TARIFF_PLAN}vehicle-by-spot/${spotId}`,
          opts,
        );
        const { vehicle } = await data.json();
        return vehicle;
      } catch (error) {
        console.error(error);
      }
    },
    async parkVehicleInSpot() {
      const fileNames = this.spots.map(spot => ({
        fileName: spot.fileName + '.jpg',
        label: spot.label,
      }));
      const payload = {
        licencePlate: this.form.licencePlate.toLowerCase(),
        parkId: this.spots[0].parkingId,
        fileName: fileNames,
        spotId: this.spots[0].spotId,
      };

      const opts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      };
      try {
        await fetch(`${URI_ORIANA}park`, opts);
        this.form.licencePlate = '';
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
